import { createFileRoute } from '@tanstack/react-router'

import { DepartmentsSection } from '@/features/organization/departments-section'
import { useAuth } from '@/hooks/use-auth'

export const Route = createFileRoute('/_app/organizacao/setores')({
  component: SetoresTab,
})

function SetoresTab() {
  const { currentOrgId } = useAuth()
  return <DepartmentsSection orgId={currentOrgId} />
}
